import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_HOTELS, res.data)
  })
)

export const listHotels = ({ commit }, params) => (
  services.listHotels(params).then(res => {
    return res.data.data
  })
)

export const getHotel = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_HOTEL, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveHotel(obj).then(res => {
    commit(types.SET_HOTEL, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deleteHotel = async ({ commit }, id) => {
  await services.delHotel(id).then(res => {
    return res
  })
}
